import React, { Component } from "react";
import { invokeApig } from "../../libs/awsLib";
import { 
    Col, 
    Button, 
    Modal,
    Glyphicon,
    Tooltip, 
    OverlayTrigger 
   } from "react-bootstrap";
import LoaderButton from "../../components/LoaderButton";
import NewPerson from "./NewPerson";

export default class PersonActions extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            isDeleting: false,
            show: false,
            person:[]
        };
      
        this.handleClose = this.handleClose.bind(this);

    }

    handleClose() {
        this.setState({ show: false });
    }
    
    showConfirmDelete = () => {
    	this.setState({ show: true });
    }

    //Método que Elimina los datos del dispositivo seleccionado por id
    deletePerson() {
        return invokeApig({
          path: `/person/${this.props.personId}`,
          method: "DELETE"
        });
    }

    handleDelete = async event => {
        event.preventDefault();
    
        this.setState({ isDeleting: true });
    
        try {
          await this.deletePerson();
//          this.props.history.push("/owner");
          this.setState({ isDeleting: false, show: false });
          this.props.onAlertSuccess({ message: "Persona eliminada correctamente!" });
        } catch (e) {
          this.setState({ isDeleting: false, show: false });
          this.props.onAlertError({ message: "Error al eliminar persona!" });
        }
    }

  handleAlertSuccess = (message) => {
	this.props.onAlertSuccess(message);
  }
  handleAlertError = (message) => {
    this.props.onAlertError(message);
  }

  render(){
    const tooltipDelete = (<Tooltip id="tooltipDelete"><strong>Eliminar</strong></Tooltip>);

    return(
        <div className="col-lg col-12">
            <Col lg={6}>
            <NewPerson {...this.props} personId={this.props.personId} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
            </Col>
            <Col lg={6}>
            <center>
            <OverlayTrigger placement="top" overlay={tooltipDelete}>  
              <Button onClick={this.showConfirmDelete} >
                <Glyphicon glyph="trash" />
              </Button>
            </OverlayTrigger>  
              <Modal show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Eliminar persona</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Está seguro que quiere eliminar la persona?</Modal.Body>
                <Modal.Footer>
	              <LoaderButton bsStyle="primary" isLoading={this.state.isDeleting} onClick={this.handleDelete} text="Eliminar" loadingText="Eliminando…"/>
                  <Button onClick={this.handleClose}>Cancelar</Button>
                </Modal.Footer>
              </Modal>
            </center>
            </Col>
        </div>
    );
  }
}




















// WEBPACK FOOTER //
// ./src/containers/person/PersonActions.js